<template>
    <div class="templete no_print">
            <div class="path_title clearfix">
                <span class="path_title_name">销售单锁定时间设置</span>
                <div class="contractLabel" style="position:relative;">
                    <span class="redQuestion"></span>
                    <div class="labelTip">
                        <div class="labelZhu">注:</div>
                        <div class="laCbelTipC">设置锁定时间开启或关闭时，需要重新登录系统后才会生效。</div>
                    </div>
                </div>
            </div>
            <div>
                <span>新建销售订单</span>
                <el-input class="input_box" v-model="orderTime" @change="timeChange" placeholder="" size="mini"></el-input>
                <span>小时内未收款、未结算、财务审核未通过，自动取消订单</span>
            </div>
            <div class="path_switch">
                <el-radio-group v-model="radio" @change="timeChange">
                    <el-radio :label="1">开启</el-radio>
                    <el-radio :label="0">关闭</el-radio>
                </el-radio-group>
            </div>
            <div class="path_title clearfix">
                <span class="path_title_name">销售单跳过审核设置</span>
                <div class="contractLabel" style="position:relative;">
                    <span class="redQuestion"></span>
                    <div class="labelTip">
                        <div class="labelZhu">注:</div>
                        <div class="laCbelTipC">开启前请检查是否有待审核单据</div>
                    </div>
                </div>
            </div>
            <div class="path_switch" style="padding-top:10px;">
                <el-radio-group v-model="reviewType" @change="reviewChange">
                    <el-radio :label="1">开启</el-radio>
                    <el-radio :label="0">关闭</el-radio>
                </el-radio-group>
            </div>
            <div class="path_title clearfix">
                <span class="path_title_name">允许销售单价为0</span>
            </div>
            <div class="path_switch" style="padding-top:10px;">
                <el-radio-group v-model="saleType" @change="saleChange">
                    <el-radio :label="1">开启</el-radio>
                    <el-radio :label="0">关闭</el-radio>
                </el-radio-group>
            </div>
            <div class="path_title clearfix">
                <span class="path_title_name">销售单锁定等级设置</span>
                <div class="contractLabel" style="position:relative;">
                    <span class="redQuestion"></span>
                    <div class="labelTip">
                        <div class="labelZhu">注:</div>
                        <div class="laCbelTipC">设置锁定等级开启或关闭时，需要重新登录系统后才会生效。</div>
                    </div>
                </div>
            </div>
            <!-- <div class="path_title">销售单锁定等级设置</div> -->
            <div class="path_switch" style="padding-top:10px;">
                <el-radio-group v-model="radioGrade" @change="gradeChange">
                    <el-radio :label="1">开启</el-radio>
                    <el-radio :label="0">关闭</el-radio>
                </el-radio-group>
            </div>
            <section class="gradeSection">
                <div class="path">
                    <span class="title">锁定等级</span>
                    <div class="">
                        <i class="el-icon-refresh" @click="getList(1)"></i>
                        <el-button type="danger" @click="addDialogVisible=!addDialogVisible;type=2;" size="mini">新增</el-button>
                    </div>
                </div>
                <div class="table_path">
                    <el-table :data="list" style="width: 100%" height="100%" size="mini" header-cell-class-name="list_table_th text-center">
                        <el-table-column label="操作" width="70">
                            <template slot-scope="scope">
                                <div class="icon_wrap">
                                    <i class="operation_edit" @click="edit(scope.row.id)" title="修改"></i>
                                    <i class="operation_delete" @click="del(scope.row.id)" title="删除"></i>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="等级" prop="name" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div class="starTableList clearfix">
                                    <div class="star gradeStar" v-for="index of parseInt(scope.row.name)" :key="index"></div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="等级说明" prop="description" show-overflow-tooltip></el-table-column>
                        <el-table-column label="状态" width="100">
                            <template slot-scope="scope">
                                <div :class="scope.row.status==1?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row.id,scope.row.status)">{{scope.row.status_label}}</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </section>
            <!--新增 START-->
            <el-dialog v-dialog-drag title="添加等级" :visible.sync="addDialogVisible" width="400px" class="eldialog eldialogGrade" :model="false">
                <div class="gradeInput clearfix">
                    <div>等级: </div>
                    <input v-model="addObj.name" class="gradeNumberBox" max="5" @input="changeStar" type="number"/>
                    <div>星</div>
                </div>
                <div class="starList clearfix">
                    <div class="star gradeStar" v-for="index of starNumber" :key="index"></div>
                </div>
                <textarea class="edit_input edit_textarea" v-model="addObj.description" placeholder="等级说明"></textarea>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn" @click="add">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisible = false">取消</el-button>
                </div>
            </el-dialog>
            <!--新增 END-->
         </div>
</template>
<style scoped lang="scss">
    .templete{overflow: auto;}
    .contractLabel{float: left;position: relative;top:3px;margin-left:10px;}
    .path_title_name{float: left;}
    .redQuestion{display: block;width:15px;height:15px;background: url('/icon/question.png') no-repeat 100%;background-size: 100% 100%;}
    .labelTip{display: none;position: absolute;top:20px;left:-150px;z-index:1;width:210px;text-align: left;background-color: #fff;border-radius: 4px;padding:10px;box-sizing: border-box;box-shadow: 1px 1px 5px #ccc;padding-left:30px;}
    .laCbelTipC{color:#606266;font-size: 12px;}
    .labelZhu{font-size: 12px;color:#b21111;position: absolute;top:10px;left:10px;}
    .contractLabel:hover{cursor: pointer;}
    .contractLabel:hover .labelTip{display: block;}
    .path_title{text-align: left;
        font-size:16px; font-weight:bold; margin-top: 26px;margin-bottom:20px;
        & + div{ margin-bottom: 20px; color: #333333; display: flex; align-items: center; }
    }
    .input_box{ width:80px; margin: 0 10px; }
    .container{
        padding: 34px 30px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
    }
    .path_switch{text-align: left;margin-bottom:20px;}
    .path{
            margin-bottom: 7px; display: flex; align-items: center; justify-content: space-between;
            .title{
                font-size:16px; font-weight:bold; color: #333333; border-left:4px solid #b21111; padding-left: 12px;
            }
        }
    .table_path{ flex: 1; box-shadow:0px 0px 10px rgba(94,94,94,0.16); border-radius:3px; width: 100%; padding: 8px 10px;  }
    .el-icon-refresh{margin-right:10px;cursor: pointer;color:#F9A602;font-weight: 600;}
    .gradeSection{width:700px;flex: 1;display: flex;flex-direction: column;}
    // .starList{margin-bottom:10px;}
    .starTableList .gradeStar{position: relative;top:5px;float: left;}
    .gradeStar{margin-right: 10px;margin-bottom:10px;}
</style>
<script>
    export default {
        components:{
        },
        data(){
            return{
                params:{
                    keyword: "",
                    per_page: 20
                },
                last_page: 10,
                current_page: 1,
                total: 1000,
                list : [],
                radio : "",
                radioGrade:"",
                reviewType:"",
                orderTime:"",
                saleType:"",
                type:2,//2.新增 3.修改
                addDialogVisible:false,
                starNumber:0,
                addObj:{
                    name:"",
                    description:""
                }
            }
        },
        created(){
            this.getList()
            this.postFunc("/erp/system.get.config",{key:"SALE_LOCK_SET"},res=>{
                this.radio = res.data.data.status;
                this.orderTime = res.data.data.value;
            },error=>{
                this.tip(error.data.message,"warning")
            })
            this.postFunc("/erp/system.get.config",{key:"LOCK_LEVEL"},res=>{
                this.radioGrade = res.data.data.status;
            },error=>{
                this.tip(error.data.message,"warning")
            })
            this.postFunc("/erp/system.get.config",{key:"SALES_REVIEW_IGNORE"},res=>{
                this.reviewType = res.data.data.status;
            },error=>{
                this.tip(error.data.message,"warning")
            })
            this.postFunc("/erp/system.get.config",{key:"SALES_ZERO_IGNORE"},res=>{
                this.saleType = res.data.data.status;
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        methods:{
            timeChange(){
                this.postFunc("/erp/system.set.config",{key:"SALE_LOCK_SET",status:this.radio,value:this.orderTime},()=>{
                    this.tip("操作成功","success")
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            reviewChange(val){
                this.postFunc("/erp/system.set.config",{key:"SALES_REVIEW_IGNORE",status:val,value:1},()=>{
                    this.tip("操作成功","success")
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            gradeChange(val){
                this.postFunc("/erp/system.set.config",{key:"LOCK_LEVEL",status:val,value:1},()=>{
                    this.tip("操作成功","success")
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            saleChange(val){
                this.postFunc("/erp/system.set.config",{key:"SALES_ZERO_IGNORE",status:val,value:1},()=>{
                    this.tip("操作成功","success")
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            changeStar(val){
                // this.$set(this.starNumber,val.target.value)
                if(parseInt(val.target.value)>5){
                    this.addObj.name=5;
                }
                if(parseInt(val.target.value)<1){
                    this.addObj.name=1;
                }
                this.starNumber = parseInt(this.addObj.name)
            },
            changeStatus(id,status){
                if(status==1){
                    status=0
                }else{
                    status=1
                }
                this.postFunc("/erp/lock.level.status",{id:id,status:status},()=>{
                    this.tip("修改成功","success")
                    this.getList()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            edit(id){
                this.list.forEach(item=>{
                    if(item.id==id){
                        this.addObj = JSON.parse(JSON.stringify(item));
                        this.starNumber = parseInt(this.addObj.name);
                    }
                })
                this.type=3;
                this.addDialogVisible=true;
            },
            del(id){
                this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    this.postFunc("/erp/lock.level.delete",{id:id},()=>{
                        this.getList()
                        this.tip("删除成功","success")
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getList(showMessage){
                this.postFunc("/erp/lock.level.list",{},res=>{
                    this.list = res.data.data;
                    if(showMessage){
                        this.tip("刷新成功","success")
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            add(){
                let url="";
                if(this.type==2){
                    url="/erp/lock.level.create";
                }else if(this.type==3){
                    url="/erp/lock.level.update";
                }
                this.postFunc(url,this.addObj,()=>{
                    this.addDialogVisible=false;
                    if(this.type==2){
                        this.tip("添加成功","success")
                    }else{
                        this.tip("修改成功","success")
                    }
                    this.getList()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.current_page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
        watch:{
            addDialogVisible:function(val){
                if(!val){
                    this.addObj = this.resetJson(this.addObj)
                    this.starNumber = 0;
                }
            },
            starNumber:function(val){
                if(!val){
                    this.starNumber = 0;
                }else{
                    if(parseInt(val)>5){
                        this.starNumber=5;
                    }
                    if(parseInt(val)<1){
                        this.starNumber=1;
                    }
                }
            }
        }
    }
</script>
